import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=fab65e3e&"
import script from "./TextWidget.vue?vue&type=script&lang=js&"
export * from "./TextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab65e3e')) {
      api.createRecord('fab65e3e', component.options)
    } else {
      api.reload('fab65e3e', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=fab65e3e&", function () {
      api.rerender('fab65e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/TextWidget.vue"
export default component.exports